module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (147).6ba011a1.jpg";